class ProductRating extends HTMLElement {
  connectedCallback () {
    this.hasSummary = this.dataset.hasSummary === 'true'
    this.hasReviews = this.dataset.hasReviews === 'true'

    if (!this.hasReviews) {
      this.classList.remove('cursor-pointer')
      this.removeAttribute('role')
      this.removeAttribute('tabindex')
      return
    }

    this.addEventListener('click', this.handleClick.bind(this))
    this.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  handleKeydown (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.handleClick(event)
    }
  }

  handleClick (event) {
    event.preventDefault()
    if (this.hasSummary) {
      this.openSummaryModal()
    } else {
      this.scrollToReviews()
    }
  }

  scrollToReviews () {
    const target =
      document.querySelector('tb-product-reviews') ||
      document.getElementById('fulfilled-reviews-all') ||
      document.getElementById('klaviyo-product-reviews-wrapper') ||
      document.getElementById('reviews') ||
      document.querySelector('.kl_reviews_summary') ||
      document.querySelector('.klaviyo-reviews')

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  openSummaryModal () {
    const summaryText = this.dataset.summary || 'No summary available.'
    const averageRating = this.querySelector('.product-rating__average-rating span')?.textContent || '0'
    const reviewCount = this.querySelector('.product-rating__total-reviews span')?.textContent || '(0)'
    const starsHtml = this.querySelector('.product-rating__stars')?.innerHTML || ''

    const modalContent = `
      <div class="product-rating__modal">
        <div class="flex items-center gap-2 mb-4">
          <div class="flex items-center text-gold">
            ${starsHtml}
          </div>
          <span class="font-medium text-lg">${parseFloat(averageRating).toFixed(1)}</span>
        </div>

        <h2 class="text-2xl font-bold mb-4">Summary</h2>

        <p class="mb-6 leading-relaxed">
          ${summaryText}
        </p>

        <button
          type="button"
          class="see-all-reviews-button button button-primary button-sm"
        >
          View all ${reviewCount.replace(/[()]/g, '')} reviews
        </button>
      </div>
    `

    const modal = document.querySelector('.reusable-modal')
    if (!modal) {
      this.scrollToReviews()
      return
    }

    const modalBody = modal.querySelector('.reusable-modal__body')
    if (modalBody) {
      modalBody.innerHTML = modalContent

      setTimeout(() => {
        const button = modalBody.querySelector('.see-all-reviews-button')
        if (button) {
          button.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('close:modal'))
            setTimeout(() => this.scrollToReviews(), 100)
          })
        }
      }, 100)
    }

    window.dispatchEvent(
      new CustomEvent('open:modal', {
        detail: {
          modalClassAdd: ['px-4', 'py-6', 'md:p-6'],
          headerClassAdd: ['absolute', 'h-[80px]', 'top-0', 'left-0', 'right-0', 'z-20', 'block'],
          headerClassRemove: ['border-b', 'mb-4', 'pb-2', 'grid'],
          closeClassAdd: ['absolute', 'top-4', 'right-4', 'z-20'],
          closeClassRemove: [],
        },
      }),
    )
  }
}

if (!customElements.get('product-rating')) {
  customElements.define('product-rating', ProductRating)
}
